import React from 'react';
import {
  baseDeleteQuery,
  basePostQuery,
  createGuest,
} from '../../../../utility/sb-api/sb-api.service';
import { notification } from '../../../../utility/notification/notification.service';

export const handleLike = (
  me,
  intl,
  id,
  isAdminMode,
  isLiked,
  setShowLikeAnimation,
  fetchOnAuthenticated,
  onSuccessCallback,
  setWebSocketToken,
) => {
  if (!isAdminMode) {
    const path = `user/items/food/${id}/like`;
    setShowLikeAnimation(true);

    (me
      ? Promise.resolve()
      : createGuest({ locale: intl?.locale.split('-')[0] }, setWebSocketToken).then(() =>
          fetchOnAuthenticated(),
        )
    )
      .then(() => (isLiked ? baseDeleteQuery(path) : basePostQuery(path)))
      .then(() => onSuccessCallback());
  } else {
    notification('warning', 'likeItemNotAllowed');
  }
};

export const removeItem = (isVariation, id, storeId, onSuccessCallback) => {
  baseDeleteQuery(
    isVariation ? `manager/stores/${storeId}/item-data/food/${id}` : `manager/stores/${storeId}/items/food/${id}`,
    null,
    isVariation ? 'removeItemVariationSuccess' : 'removeItemSuccess',
    isVariation ? 'removeItemVariationError' : 'removeItemError',
  ).then(() => onSuccessCallback());
};
